export default "__VITE_ASSET__5PxN4tPs__"